import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';
import { handleError } from '../../utils/handleError';

const initialState = {
  isLoading: true,
  error: null,
  message: null,
  liveShares: [],
  pagination: null,
};

export const fetchAllLiveShares = createAsyncThunk(
  'liveShares/fetchAll',
  async ({ page = 1, limit = 10, keyWord = '' }, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get(`/admin/live-share/fetch-all?page=${page}&limit=${limit}&keyWord=${keyWord}`);
      return res.data;
    } catch (error) {
      return rejectWithValue(handleError(error));
    }
  }
);
export const deleteLiveShares = createAsyncThunk(
  'liveShares/delete',
  async (ids = [], { rejectWithValue }) => {
	try {
		const res = await axiosInstance.delete(`/admin/live-share/bulk`, { data:{ ids } });
		return res.data;
	} catch (error) {
		return rejectWithValue(handleError(error));
	}
});

const liveShareSlice = createSlice({
  name: 'liveShares',
  initialState,
  reducers: {
    clearError: (state) => { state.error = null; },
    clearMessage: (state) => { state.message = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllLiveShares.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAllLiveShares.fulfilled, (state, action) => {
        state.isLoading = false;
        state.liveShares = action.payload?.liveShares || [];
        state.pagination = action.payload?.pagination || null;
      })
      .addCase(fetchAllLiveShares.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || 'Unable to fetch live shares';
      });
  }
});

export const { clearError, clearMessage } = liveShareSlice.actions;
export default liveShareSlice.reducer;
